import { CardioSelectedIcon } from "@images/svgIcons/cardioIcon"
import { GymSelectedIcon } from "@images/svgIcons/gymIcon"
import { WeightliftingSelectedIcon } from "@images/svgIcons/weightliftingIcon"
import { Modality } from "@modules/profile/publicProfile/publicProfileTypes"
import { DefaultTheme } from "styled-components"

export const getModalityColor = (modality: Modality, theme: DefaultTheme) => {
  switch (modality) {
    case Modality.WEIGHT_LIFTING:
      return theme.base.purple500
    case Modality.GYM:
      return theme.base.green500
    case Modality.METCON:
      return theme.base.orange500
    default:
      return theme.neutralColor
  }
}

export const getModalityTagImage = (modality: Modality, size: number) => {
  return {
    [Modality.GYM]: <GymSelectedIcon color="" width={size} height={size} />,
    [Modality.WEIGHT_LIFTING]: <WeightliftingSelectedIcon color="" width={size} height={size} />,
    [Modality.METCON]: <CardioSelectedIcon color="" width={size} height={size} />,
  }[modality]
}
